module.exports = __webpack_public_path__ + "static/media/tj.a0865ff4.svg";